import { z } from 'zod';
import { relationshipsContactSchema, relationshipsOrganizationIdSchema, } from './relationships-contact.contract.js';
export const relationshipsOrganizationTypeSchema = z.enum([
    'customer',
    'insurance',
    'vendor',
    'adjuster',
    'property_manager',
    'other',
]);
export const relationshipsOrganizationStatusSchema = z.enum([
    'active',
    'difficult',
    'preferred',
    'inactive',
]);
export const relationshipsOrganizationSchema = z.strictObject({
    id: relationshipsOrganizationIdSchema,
    tenantId: z.string().uuid(),
    name: z.string().min(1).max(240),
    type: relationshipsOrganizationTypeSchema,
    phone: z.string().max(60).nullable(),
    email: z.string().email().max(320).nullable(),
    addressLine1: z.string().max(240).nullable(),
    addressLine2: z.string().max(240).nullable(),
    city: z.string().max(120).nullable(),
    region: z.string().max(120).nullable(),
    postalCode: z.string().max(20).nullable(),
    countryCode: z.string().regex(/^[A-Z]{2}$/),
    website: z.string().max(320).nullable(),
    status: relationshipsOrganizationStatusSchema,
    notes: z.string().max(10_000).nullable(),
    contactCount: z.number().int().nonnegative(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const relationshipsOrganizationListQuerySchema = z.strictObject({
    search: z.string().trim().min(1).max(160).optional(),
    type: relationshipsOrganizationTypeSchema.optional(),
    status: relationshipsOrganizationStatusSchema.optional(),
    limit: z.number().int().min(1).max(100).default(50),
    offset: z.number().int().min(0).default(0),
});
export const relationshipsCreateOrganizationSchema = z.strictObject({
    name: z.string().trim().min(1).max(240),
    type: relationshipsOrganizationTypeSchema.default('customer'),
    phone: z.string().trim().max(60).nullable().default(null),
    email: z.string().trim().email().max(320).nullable().default(null),
    addressLine1: z.string().trim().max(240).nullable().default(null),
    addressLine2: z.string().trim().max(240).nullable().default(null),
    city: z.string().trim().max(120).nullable().default(null),
    region: z.string().trim().max(120).nullable().default(null),
    postalCode: z.string().trim().max(20).nullable().default(null),
    countryCode: z.string().regex(/^[A-Z]{2}$/).default('US'),
    website: z.string().trim().max(320).nullable().default(null),
    status: relationshipsOrganizationStatusSchema.default('active'),
    notes: z.string().trim().max(10_000).nullable().default(null),
});
export const relationshipsUpdateOrganizationSchema = z.strictObject({
    name: z.string().trim().min(1).max(240).optional(),
    type: relationshipsOrganizationTypeSchema.optional(),
    phone: z.string().trim().max(60).nullable().optional(),
    email: z.string().trim().email().max(320).nullable().optional(),
    addressLine1: z.string().trim().max(240).nullable().optional(),
    addressLine2: z.string().trim().max(240).nullable().optional(),
    city: z.string().trim().max(120).nullable().optional(),
    region: z.string().trim().max(120).nullable().optional(),
    postalCode: z.string().trim().max(20).nullable().optional(),
    countryCode: z.string().regex(/^[A-Z]{2}$/).optional(),
    website: z.string().trim().max(320).nullable().optional(),
    status: relationshipsOrganizationStatusSchema.optional(),
    notes: z.string().trim().max(10_000).nullable().optional(),
});
export const relationshipsOrganizationsResponseSchema = z.strictObject({
    data: z.array(relationshipsOrganizationSchema),
    page: z.strictObject({
        limit: z.number().int().positive(),
        offset: z.number().int().nonnegative(),
        returned: z.number().int().nonnegative(),
        total: z.number().int().nonnegative(),
    }),
});
export const relationshipsOrganizationResponseSchema = z.strictObject({
    data: relationshipsOrganizationSchema,
});
export const relationshipsOrganizationDetailResponseSchema = z.strictObject({
    data: relationshipsOrganizationSchema,
    contacts: z.array(relationshipsContactSchema),
});
//# sourceMappingURL=relationships-organization.contract.js.map